/*globals google*/
(function () {
	'use strict';

	angular
		.module('invesfleet')
		.controller('informeVolumenOrdenesPorRangoHorarioController', informeVolumenOrdenesPorRangoHorarioController);

	informeVolumenOrdenesPorRangoHorarioController.$inject = [
		'$stateParams', 'genericDataService', '$rootScope', '$state',
		'$filter', '$q', '$scope'];

	/* jshint maxstatements:false */
	/* jshint maxparams:false */
	function informeVolumenOrdenesPorRangoHorarioController($stateParams, genericDataService,
		$rootScope, $state, $filter,
		$q, $scope) {

		/* PUBLIC VARIABLES */
		var vm = this;
		vm.init = init;
		vm.genericDataService = genericDataService;
		vm.clickFinalDate = clickFinalDate;
		vm.clickInitDate = clickInitDate;
		vm.clickOptionFechas = clickOptionFechas;

		vm.volumenOrdenesList = []; 
		vm.weekday = new Array(7);
		vm.lunes = null;
		vm.martes = null;
		vm.meircoles = null;
		vm.jueves = null;
		vm.viernes = null;
		vm.sabado = null;
		vm.domingo = null;
		vm.total = null;
		vm.visibilitiInputDates = false;

		vm.data = {
			fechaIni: '',
			fechaFin: '',
			horaIni: new Date('8/24/2009 00:00'),
			horaFin: new Date('8/24/2009 23:59'),
		};

		vm.genericData = {
			empresas: {
				list: null,
				selected: { id: null }
			},
			dateOpts: {
				list: [
					{ nombre: 'Esta semana', id: 'week' },
					{ nombre: 'La semana pasada', id: 'lastWeek' },
					{ nombre: 'Personalizado', id: 'custom' },
				],
				selected: { nombre: 'La semana pasada', id: 'lastWeek' }
			}
		};

		vm.dateOpts = 

		(function () {
			vm.weekday[0] = 'Sunday';
			vm.weekday[1] = 'Monday';
			vm.weekday[2] = 'Tuesday';
			vm.weekday[3] = 'Wednesday';
			vm.weekday[4] = 'Thursday';
			vm.weekday[5] = 'Friday';
			vm.weekday[6] = 'Saturday';
			loadData();
		})();

		function loadData() {
			getGenericData();
		}

		function init(parentVm) {
			parentVm.getData = getData;
			parentVm.loadResult = loadResult;

		}

		function getGenericData() {
			vm.genericDataService.getEmpresas()
				.then(function (result) {
					vm.genericData.empresas.list = result;
				});
		}

		function getData() {
			var data = {};
			data.url = '/INVESFLEET/rpt_informeVolumenOrdenesPorRangoHorario';
			data.message = 'Todos los campos son obligatorios';
			data.valid = doValidation(data);
			data.queryType = 'customQuery';
			
			if (data.valid) {
				var date = new Date();
				data.datosPeticion = [
					{ field: 'fechaInicio', value: getValueComboFechas(vm.data.fechaIni, 0, 7)  },
					{ field: 'fechaFin', value: getValueComboFechas(vm.data.fechaFin, 7, 0) },
					{ field: 'empresaId', value: getEmpresasSelected()  },
					{ field: 'horaInicio', value: vm.data.horaIni },
					{ field: 'horaFin', value: vm.data.horaFin },
				];
				vm.data.horaIni.setYear(date.getUTCFullYear());
				vm.data.horaIni.setMonth(date.getMonth());
				vm.data.horaIni.setDate(date.getDate());

				vm.data.horaFin.setYear(date.getUTCFullYear());
				vm.data.horaFin.setMonth(date.getMonth());
				vm.data.horaFin.setDate(date.getDate());
			}
			return data;
		} 

		function getValueComboFechas(fecha, diaApplyWeek, diaApllyLastWeek ) {
			var today = Date.NewDate();
			var value = null;
			switch (vm.genericData.dateOpts.selected.id) {
				case 'lastWeek':
					value = new Date(today.getFullYear(), today.getMonth(), 
						today.getDate() - (today.getDay() - 1) - diaApllyLastWeek, 0, 0, 0);
					break;
				case 'week':
					value = new Date(today.getFullYear(), today.getMonth(), 
						today.getDate() - (today.getDay() - 1) + diaApplyWeek, 0, 0, 0);
					break;
				case 'custom':
					value = fecha;
					if (diaApplyWeek === 7) { value.setDate(value.getDate() + 1); }
					break;
			}
			return value;
		}

		function loadResult(result) {
			vm.volumenOrdenesList = result;
			if (vm.volumenOrdenesList.length > 0) {
				vm.lunes = vm.volumenOrdenesList.map(a => a.Lunes).reduce((prev, next) => prev + next);
				vm.martes = vm.volumenOrdenesList.map(a => a.Martes).reduce((prev, next) => prev + next);
				vm.miercoles = vm.volumenOrdenesList.map(a => a.Miercoles).reduce((prev, next) => prev + next);
				vm.jueves = vm.volumenOrdenesList.map(a => a.Jueves).reduce((prev, next) => prev + next);
				vm.viernes = vm.volumenOrdenesList.map(a => a.Viernes).reduce((prev, next) => prev + next);
				vm.sabado = vm.volumenOrdenesList.map(a => a.Sabado).reduce((prev, next) => prev + next);
				vm.domingo = vm.volumenOrdenesList.map(a => a.Domingo).reduce((prev, next) => prev + next);
				vm.total = vm.volumenOrdenesList.map(a => a.Total).reduce((prev, next) => prev + next);
			}
		}

		function doValidation(data) {
			if (vm.genericData.dateOpts.selected.id === 'custom') {
				if (!vm.data.fechaIni) { return false; }
				if (!vm.data.fechaFin) { return false; }
			}
			if (!vm.data.horaIni) { return false; }
			if (!vm.data.horaFin) { return false; }
			//if (vm.genericData.empresas.selected.length === 0) { return false; }
			if (vm.data.fechaFin < vm.data.fechaIni) {
				data.message = 'Las franjas de tiempo iniciales deben ser inferiores a las finales';
				return false;
			}
			return true;
		}

		function clickInitDate(date) {
			if (date !== null && date !== undefined && date !== '') {
			var n = vm.weekday[date.getDay()];
				if (n !== 'Monday') {
					date = undefined;
					vm.data.fechaIni = '';
					alert('Introduce un Lunes');
				}
			}
		}

		function clickFinalDate(date) {
			if (date !== null && date !== undefined && date !== '') {
				var n = vm.weekday[date.getDay()];
				if (n !== 'Sunday') {
					date = undefined;
					vm.data.fechaFin = '';
					alert('Introduce un Domingo');
				}
			}
		}

		function clickOptionFechas() {
			if (vm.genericData.dateOpts.selected.id === 'custom') {
				vm.visibilitiInputDates = true;
			}
			else {
				vm.visibilitiInputDates = false;
			}
		}

		function getEmpresasSelected() {
			if (vm.genericData.empresas.selected.length === 0) {
				return []; 
			}
			return vm.genericData.empresas.selected.map(a => a.id);
		}

	}
})();